import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

const DEFAULT_LIMIT = 50;

const buildUrl = (limit = DEFAULT_LIMIT) => {
  const url = new URL(`${config.api.url}/organization/open-labor-episodes`);
  url.searchParams.set('limit', String(limit));
  return url.toString();
};

const openLaborEpisodesApi = {
  /**
   * @param {{ limit?: number }} [options]
   * @returns {Promise<{ items: Array<{
   *   laborEpisodeReferenceId: string,
   *   pregnancyReferenceId: string,
   *   clientReferenceId: string,
   *   displayName: string,
   *   chartStatus: string | number,
   *   hasLaborTransfer: boolean,
   *   isPushing: boolean,
   * }>, hasMore: boolean }>}
   */
  async list(options = {}) {
    const limit = options.limit ?? DEFAULT_LIMIT;
    const response = await fetch(buildUrl(limit), {
      headers: getAuthHeaders(),
    });
    return handleResponse(response);
  },
};

export default openLaborEpisodesApi;
